import { ChangeDetectorRef, Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { AppComponentBase } from '@shared/app-component-base';
import { BaseMessageNotificationDataDto, ReminderNotificationDto, ReminderServiceProxy } from '@shared/service-proxies/service-proxies';
import { CreateOrEditReminderComponent } from './create-or-edit-reminder/create-or-edit-reminder.component';
import { CustomModalService } from '@shared/helpers/custom-modal.service';
import { ReminderCountUpdatedService } from '@shared/helpers/reminder-count-updated.service';

@Component({
  selector: 'app-reminders',
  templateUrl: './reminders.component.html',
  styleUrl: './reminders.component.css'
})
export class RemindersComponent extends AppComponentBase implements OnInit {
  remindersList: ReminderNotificationDto[];
  dropdownOpenId: string | null = null;

  @Output() closePopover: EventEmitter<void> = new EventEmitter();

  tooltipsVisible: { [key: string]: boolean } = {};

  showTooltip(id: string): void {
    this.tooltipsVisible[id] = true;
  }

  hideTooltip(id: string): void {
    this.tooltipsVisible[id] = false;
  }

  constructor(
    injector: Injector,
    private _reminderService: ReminderServiceProxy,
    private _reminderCountUpdatedService: ReminderCountUpdatedService,
    private cdr: ChangeDetectorRef,
    private _modalService: CustomModalService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this._reminderService
    .getUnreadReminderNotificationsByUserId(this.appSession.userId)
    .subscribe((result: ReminderNotificationDto[]) => {
      this.remindersList = result;
      this.cdr.detectChanges();
    });
  }

  setNotificationAsRead(notificationId: number): void {
    this._reminderService
    .checkReadNotificationById(notificationId)
    .subscribe({
      next: () => {
        this.remindersList = [];
        this._reminderCountUpdatedService.setNewReminderRefresh(true);
        this._reminderCountUpdatedService.notifyReminderRead();
        this.ngOnInit();
      }
    });
  }

  timeSince(notificationDate: Moment): string {
    const now = moment();
    const duration = moment.duration(now.diff(notificationDate));

    const days = Math.floor(duration.asDays());
    const hours = Math.floor(duration.asHours() % 24);
    const minutes = Math.floor(duration.asMinutes() % 60);
    const seconds = Math.floor(duration.asSeconds() % 60);

    if (days > 0) {
        const dayText = this.l('day');
        const daysText = this.l('days');
        return days === 1 ? `1 ` + dayText : `${days} ` + daysText;
    } else if (hours > 0) {
        const hourText = this.l('hour');
        const hoursText = this.l('hours');
        return hours === 1 ? `1 ` + hourText : `${hours} ` + hoursText;
    } else if (minutes > 0) {
        const minuteText = this.l('minute');
        const minutesText = this.l('minutes');
        return minutes === 1 ? `1 ` + minuteText : `${minutes} ` + minutesText;
    } else {
        const secondText = this.l('second');
        const secondsText = this.l('seconds');
        return seconds === 1 ? `1 ` + secondText : `${seconds} ` + secondsText;
    }
  }

  toggleDropdown(notificationId: string) {
    if (this.dropdownOpenId === notificationId) {
      this.dropdownOpenId = null;
    } else {
      this.dropdownOpenId = notificationId;
    }
  }

  isDropdownOpen(notificationId: string): boolean {
    return this.dropdownOpenId === notificationId;
  }

  navigateToComponent(): Promise<boolean> {
    this.closePopover.emit();
    return this.router.navigateByUrl('/app/reminders-diary');
  }

  create() {
    this.closePopover.emit();
    this._modalService.show(
      CreateOrEditReminderComponent,
      {
        class: 'modal-xm',
        closeInterceptor: () => Promise.reject(),
        initialState: {
          title: this.l('CreateReminder')
        },
      }
    );
  }
}
